<template>
  <ModalConfirmation
    hasBlur
    :primaryButtonProps="modalContent.primaryButtonProps"
    :showModal="showModal"
    title="Delete Administrator Account"
    @close="handleClose"
    @save="handleSave"
  >
    <template v-slot:body>
      <ParagraphBody
        v-for="text in modalContent.text"
        :key="text"
      >
        {{ text }}
      </ParagraphBody>
    </template>
  </ModalConfirmation>
</template>

<script>
import {
  ModalConfirmation,
  ParagraphBody,
  Types,
} from '@jumpcloud/ui-components';

const { PrimaryButtonProps } = Types;

export default {
  name: 'ModalDeleteAccount',

  components: {
    ModalConfirmation,
    ParagraphBody,
  },

  props: {
    item: {
      type: Object,
      required: true,
    },
    showModal: Boolean,
  },

  computed: {
    modalContent() {
      const { email } = this.item;

      const text = [
        "Deleting an account will immediately delete and remove this administrators's access to the Admin Portal.",
        `Are you sure you want to delete ${email}?`,
      ];

      return {
        primaryButtonProps: PrimaryButtonProps({
          text: 'delete',
        }),
        text,
      };
    },
  },

  methods: {
    handleClose() {
      this.$emit('close');
    },

    handleSave() {
      this.$emit('save');
    },
  },
};
</script>
